import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { useUpdateSettlementRule } from '../queries';
import { prepareSettlementRuleValues } from '../utils';
import { WithPaymentPolicyId } from '../types';
import { FormValues } from './schema';
import { UpdatePaymentPolicyFormContent } from './PaymentPolicyFormContent';

export const useUpdatePaymentPolicyDialogForm = ({ paymentPolicyId }: WithPaymentPolicyId) => {
    const { mutateAsync } = useUpdateSettlementRule();

    const handleSubmit = async (formValues: FormValues) =>
        mutateAsync({ id: paymentPolicyId, ...prepareSettlementRuleValues(formValues) });

    return useDialogForm({
        id: `update-payment-policy-${paymentPolicyId}`,
        title: lt('PaymentPolicyEdit'),
        renderForm: (props) => (
            <UpdatePaymentPolicyFormContent paymentPolicyId={paymentPolicyId} onSubmit={handleSubmit} {...props} />
        ),
    });
};
